"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const native_base_1 = require("native-base");
exports.default = native_base_1.VStack;
